import Vue from 'vue'
import authority from "./src/authority"
import dialogDrag from "./src/directives"
import keyupFocus from "./src/keyupFocus";
import drag from "./src/drag"
import loadMore from "./src/loadMore"
import txtPro from "./src/txtPro"
import { verify, formVerify } from "./src/verify/formVerify"
import numberInput from "./src/number-input/index"
import debounce from "./src/debounce"
import btnCountdown from "./src/btnCountdown"
import scanning from "./src/scanning"
import { keyboardControl } from "./src/keyboard-control/index"
import downloadFile from "./src/downloadFile";
import ellipsisDirective from '@/components/cloud-clinic/directives/ellipsis/index';
import select from '@/components/cloud-clinic/directives/select/index'
import permissionRoles from "@/components/cloud-clinic/directives/permission"
export function golbalDirective () {
  /**
   * 权限校验指令
   */
  Vue.directive('authority', authority)
  Vue.directive('dialogDrag', dialogDrag)
  Vue.directive('keyupFocus', keyupFocus)
  Vue.directive('drag', drag)
  Vue.directive("loadMore", loadMore)
  Vue.directive("txtPro", txtPro)
  Vue.directive("verify", verify)
  Vue.directive("formVerify", formVerify)
  Vue.directive("number-input", numberInput)
  Vue.directive("debounce", debounce)
  Vue.directive("countdown", btnCountdown)
  Vue.directive("scanning", scanning)
  Vue.directive("keyboard-control", keyboardControl)
  Vue.directive("downloadFile", downloadFile)
  // 注册为指令
  Vue.directive(ellipsisDirective.name, ellipsisDirective)
  Vue.directive('select', select);
  Vue.directive('permission', permissionRoles);
}



// WEBPACK FOOTER //
// ./src/directives/index.js